import { render, staticRenderFns } from "./suggestionsListOpenSearchAdder.vue.html?vue&type=template&id=a4e548a8&"
import script from "./suggestionsListOpenSearchAdder.ts?vue&type=script&lang=ts&"
export * from "./suggestionsListOpenSearchAdder.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports